module.exports = __webpack_public_path__ + "static/img/fudai_1.d6c98e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fudai_1.png
// module id = /bBt
// module chunks = 128